module.exports = __webpack_public_path__ + "static/three-349587393e868ca4a012201c43b7565f.png";